import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-preview-layout',
  imports: [RouterOutlet],
  templateUrl: './preview-layout.component.html',
  styleUrl: './preview-layout.component.scss',
})
export class PreviewLayoutComponent {}
